import { useFormContext } from 'react-hook-form'

import { Button, Grid, Input, Picker, Row } from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import { SPACING } from 'utils'

import { IForm } from '../../PesquisaMovFornecedor'

interface IFilterMovPesquisaFornecedor {
  handleSearch: (form: IForm) => void
}

export const FilterMovPesquisaFornecedor = ({
  handleSearch
}: IFilterMovPesquisaFornecedor) => {
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
    watch
  } = useFormContext<IForm>()

  const handleResetForm = () => {
    reset()
    handleSearch(watch())
  }

  return (
    <>
      <Grid
        gridCols="1.5fr 0.5fr 0.5fr 1.5fr 2fr"
        gridGap={`0 ${SPACING.spacing15}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
      >
        <Input
          control={control}
          errors={errors}
          label="Contrato"
          placeholder="Nº"
          formValue="CdContrato"
          maxLength={100}
        />
        <Picker
          control={control}
          errors={errors}
          label="Competência (Início)"
          formValue="CompetenciaInicio"
          maxDate={watch('CompetenciaFim') || null}
          placeholder="mm/aaaa"
          type="monthAndYear"
        />
        <Picker
          control={control}
          errors={errors}
          label="Competência (Fim)"
          formValue="CompetenciaFim"
          minDate={watch('CompetenciaInicio') || null}
          type="monthAndYear"
        />
        <Input
          control={control}
          errors={errors}
          label="Fornecedor"
          placeholder="Nome do Fornecedor"
          formValue="NmFornecedor"
          maxLength={100}
        />
        <Row justifyContent="flex-end" marginTop={SPACING.spacing5}>
          <Button
            text="Limpar"
            variantButton="text"
            onClick={() => handleResetForm()}
          />
          <Button
            text="Pesquisar"
            endIcon={<MagnifyingGlassIcon />}
            marginLeft={SPACING.spacing20}
            onClick={handleSubmit(handleSearch)}
          />
        </Row>
      </Grid>
    </>
  )
}
